"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoriesCode = exports.catalogsCode = exports.formioStorage = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var formioStorage = {
  catalogs: {},
  categories: {}
};
exports.formioStorage = formioStorage;
var catalogsCode = new Set();
exports.catalogsCode = catalogsCode;
var categoriesCode = new Set();
exports.categoriesCode = categoriesCode;